import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { Offer, Job } from '@app/shared';
import { listTransition } from '@app/core/animations/list-animations';
//import { OfferActionTypes } from '@app/store/actions/offer.actions';

@Component({
  selector: 'app-offer-search',
  templateUrl: './offer-search.component.html',
  styleUrls: ['./offer-search.component.scss'],
  animations: [ listTransition ]
})
export class OfferSearchComponent implements OnInit {

  @Output() onSearch = new EventEmitter<any>();
  @Output() onCloseClick = new EventEmitter<any>();
  @Input()
  public set offers(val:Offer[]){
    this._offers = val;
  }
  public get offers():Offer[]{
    return this._offers;
  }

  searchStr:string = "";
  private _offers:Offer[];

  constructor() { }

  ngOnInit() {
  }
  closeClick():void{
    this.onCloseClick.emit();
  }
  search():void{

    let oa = {offer:null,keyword:this.searchStr};

    if(this.searchStr.length)
      this.onSearch.emit(oa);
    else
      this.offers = [];
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/offer-editor/offer-search/offer-search.component.ts